// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iUxE","fullView":"styles_fullView__2mXSE"};